import React from "react";
import {
  Box,
  Paper,
  Typography,
  Select,
  MenuItem,
  TextField,
  Grid,
} from "@mui/material";
import OpenWithIcon from '@mui/icons-material/OpenWith';

function StaticCharts({ title,handleOpen,settingType }) {
  const stressBars = [
    { time: "5", stress: "low" },
    { time: "6", stress: "low" },
    { time: "7", stress: "low" },
    { time: "8", stress: "low" },
    { time: "9", stress: "low" },
    { time: "10", stress: "high" },
    { time: "11", stress: "low" },
    { time: "12", stress: "low" },
    { time: "13", stress: "low" },
    { time: "14", stress: "low" },
    { time: "15", stress: "low" },
    { time: "16", stress: "low" },
    { time: "17", stress: "low" },
    { time: "18", stress: "high" },
    { time: "19", stress: "low" },
    { time: "20", stress: "low" },
    { time: "21", stress: "low" },
    { time: "22", stress: "low" },
    { time: "23", stress: "low" },
    { time: "24", stress: "med" },
    // { time: "25", stress: "low" },
    // { time: "26", stress: "low" },
    { time: "27", stress: "low" },
    { time: "28", stress: "low" },
    // { time: "29", stress: "low" },
    { time: "30", stress: "low" },
    { time: "31", stress: "high" },
    { time: "32", stress: "low" },
    // { time: "33", stress: "low" },
    // { time: "34", stress: "low" },
    // { time: "35", stress: "low" },
    { time: "36", stress: "low" },
    // { time: "37", stress: "med" },
    // { time: "38", stress: "low" },
    // { time: "39", stress: "low" },
    { time: "40", stress: "med" },
  ];

  const data1 = [
    { name: "5", hrs: 13 },
    { name: "8", hrs: 6 },
    { name: "12", hrs: 4 },
    { name: "T1", hrs: 11 },
    { name: "5", hrs: 7 },
    { name: "8", hrs: 9 },
    { name: "12", hrs: 8 },
    { name: "T2", hrs: 4 },
    { name: "5", hrs: 5 },
    { name: "8", hrs: 6 },
    { name: "12", hrs: 7 },
    { name: "T3", hrs: 5 },
  ];
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // flex: 1,
        width: "100%",
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignContent: 'space-between' }}>
        <Typography
          variant="p"
          align="left"
          sx={{ marginLeft: 2, fontSize: "15px", fontWeight: "bold", }}
        >
          {title}
        </Typography>

        {handleOpen && <OpenWithIcon onClick={() => {
          handleOpen()
          settingType(title)
        }} sx={{ alignSelf: 'flex-end', right: 20 , cursor:'pointer',fontSize:'medium'}} />}
      </Box>

      <Box sx={{
        display: "flex", flex: 1, justifyContent: handleOpen ? 'flex-start' : 'center', overflow: 'scroll',
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}>
        {stressBars.map((data, index) => {
          if (data["stress"] === "high") {
            return (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: handleOpen ? "10px" :'20px',
                  marginLeft:'5px'
                }}
              >
                <Box
                  sx={{
                    height: handleOpen ? "78px" : '280px',
                    width:handleOpen ? "5px" : "20px",
                    backgroundColor: "#FF6445",
                    borderRadius: 10,
                    boxShadow: 1,
                    marginBottom: "5px",
                  }}
                ></Box>
                <Typography variant="p" fontSize={handleOpen ?"8px" :'10px'} sx={{ fontWeight:'bold'}}>
                  {data["time"]}
                </Typography>
              </Box>
            );
          } else if (data["stress"] === "med") {
            return (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: handleOpen ? "10px" :'20px',
                  marginLeft:'5px'
                }}
              >
                <Box
                  sx={{
                    height: handleOpen ? "63px" : '260px',
                    width:handleOpen ? "5px" : "20px",
                    backgroundColor: "#FFE882",
                    borderRadius: 10,
                    boxShadow: 1,
                    marginBottom: "5px",
                  }}
                ></Box>
                <Typography variant="p" fontSize={handleOpen ?"8px" :'10px'}sx={{ fontWeight:'bold'}}>
                  {data["time"]}
                </Typography>
              </Box>
            );
          } else {
            return (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: handleOpen ? "10px" :'20px',
                  marginLeft:'5px'
                }}
              >
                <Box
                  sx={{
                    height: handleOpen ? "49px" : '220px',
                    width:handleOpen ? "5px" : "20px",
                    backgroundColor: "#C8EDF5",
                    borderRadius: 10,
                    boxShadow: 1,
                    marginBottom: "5px",
                  }}
                ></Box>
                <Typography variant="p" fontSize={handleOpen ?"8px" :'10px'} sx={{ fontWeight:'bold'}}>
                  {data["time"]}
                </Typography>
              </Box>
            );
          }
        })}
      </Box>
      {/* <Box sx={{ display: "flex", flex: 1, flexDirection }}> */}
      {/* <Box
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          marginLeft: 2,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: 5,
            height: 5,
            backgroundColor: "#FF6445",
            borderRadius: "100%",
          }}
        ></Box>
        <Typography
          variant="p"
          fontSize={"5px"}
          marginLeft={0.5}
          marginRight={1}
        >
          High Stress
        </Typography>
        <Box
          sx={{
            width: 5,
            height: 5,
            backgroundColor: "#FFE882",
            borderRadius: "100%",
          }}
        ></Box>
        <Typography
          variant="p"
          fontSize={"5px"}
          marginLeft={0.5}
          marginRight={1}
        >
          Moderate Stress
        </Typography>
        <Box
          sx={{
            width: 5,
            height: 5,
            backgroundColor: "#FF6445",
            borderRadius: "100%",
          }}
        ></Box>
        <Typography
          variant="p"
          fontSize={"5px"}
          marginLeft={0.5}
          marginRight={1}
        >
          Low Stress
        </Typography>
        <Box
          sx={{
            width: 5,
            height: 5,
            backgroundColor: "#FFFFFF",
            border: "0.2px solid #1599EA",
            borderRadius: "100%",
          }}
        ></Box>
        <Typography
          variant="p"
          fontSize={"5px"}
          marginLeft={0.5}
          marginRight={1}
        >
          PSS
        </Typography>
      </Box> */}
      {/* </Box> */}
    </Box>
  );
}

export default StaticCharts;
